import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesSecurityLevelAddRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-security-level-add',
	path: '/secure/admin/AddIssueSecurity!default.jspa',
};
